const TV_VERSION = 'v30.3.0'

const SCRIPTS = [
  `/tradingview/${TV_VERSION}/charting_library/charting_library.standalone.js`,
  `/tradingview/${TV_VERSION}/datafeeds/udf/dist/bundle.js`,
]

let loadPromise: Promise<void> | null = null

function getCdnDomain(): string {
  const hostname = window.location.hostname

  // production: my.X => cdn.X
  const match = hostname.match(/^my\.(.+)$/)
  if (match) {
    return `cdn.${match[1]}`
  }

  // dev, test, localhost and everything else => cdn.tickmill.com
  return 'cdn.tickmill.com'
}

function loadScript(src: string): Promise<void> {
  return new Promise((resolve, reject) => {
    const existing = document.querySelector(`script[src="${src}"]`)
    if (existing) {
      resolve()
      return
    }

    const script = document.createElement('script')
    script.src = src
    script.async = true
    script.onload = () => resolve()
    script.onerror = () => reject(new Error(`Failed to load script: ${src}`))
    document.head.appendChild(script)
  })
}

export function loadTradingView(): Promise<void> {
  if (window.TradingView) {
    return Promise.resolve()
  }

  if (loadPromise) {
    return loadPromise
  }

  const cdnDomain = getCdnDomain()
  const urls = SCRIPTS.map((path) => `https://${cdnDomain}${path}`)

  loadPromise = urls
    .reduce<Promise<void>>((chain, url) => chain.then(() => loadScript(url)), Promise.resolve())
    .catch((err) => {
      loadPromise = null // allow retry on failure
      throw err
    })

  return loadPromise
}
